import Route from "next/router";
import qs from "qs";
import { getFilter } from "../collecter/get";
import { setPage } from "../shared/global";
import reporter from "./reporter";

let source_page = null;

/**
 * pv埋点  用于没有路由变化的pv埋点，比如弹框、tab页切换等
 * @param {{
 *  page_nm?:string,
 *  sub_page_nm?: string,
 *  page_params?: Object
 * }} data 页面信息  page_name sub_page_nm
 *
 * @param {Object} ext
 * @param {boolean} ext.bd_disabled 禁止百度埋点
 */
export default function pvTracker(data, { bd_disabled } = {}) {
  try {
    const trackData = {
      event_id: 39003,
      event_name: "trackPageView",
      page: window.location.origin + window.location.pathname,
      source_page: source_page || document.referrer,
      ...data,
    };

    source_page = window.location.href;

    const query = qs.parse(window.location.search, { ignoreQueryPrefix: true });

    const { _tracker_source } = query;

    if (_tracker_source) {
      trackData.source = `${trackData.page_nm}_${
        trackData.sub_page_nm || ""
      }_${_tracker_source}`;
    }

    // if (Route.router.query) {
    //   trackData.page_params = Route.router.query;
    // }

    setPage({
      page_nm: trackData.page_nm,
      sub_page_nm: trackData.sub_page_nm,
    });

    // 页面曝光补充分类上报
    const filter = getFilter(trackData.page_nm);
    if (filter) {
      Object.assign(trackData, filter);
    }
    reporter(trackData, { bd_disabled: true });

    // 页面变化时，更新前端监控的地址信息
    window.GD_SLS_RUM &&
      window.GD_SLS_RUM.trackPageTarget(Route.router.pathname);

    // 百度的pv埋点
    if (bd_disabled) return;
    if (typeof window._hmt === "undefined") {
      window._hmt = [];
    }
    // 原_hmt提交报错，改成window._hmt
    window._hmt.push(["_trackPageview", Route.router.asPath]);
  } catch (error) {
    console.error(error);
  }
}
